import { Tenant } from "./tenant";

export class Encoder {
  uuid: string;
  name: string;
  commandsSchema: string;
  creationDate: number;
  updatedDate: number;
  tenant: Tenant;
}
